module.exports = __webpack_public_path__ + "img/thumbs-down-red.2f145ad2.svg";